export default {
  dataNotLoaded: 'Data could not be loaded',
  serviceUnavailable: 'Service is currently unavailable',
  generalError: 'An error occurred. Please try again later or contact support',
  shouldDeleteItem: 'Are you sure you want to delete this item?',
  user: {
    disabled: 'Are you sure you want to block this user?',
    enabled: 'Are you sure you want to unblock this user?',
    deleted: 'Are you sure you want to delete this user?'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/messages.js